<template>
  <div>
    <div class="container">
      <b-row align-h="center">
        <b-col cols="8">
          <div class="title-div">
            <img
              class="title-bg"
              src="@/assets/images/contact-address-title-bg.png"
            />
            <img
              class="title-ico"
              src="@/assets/images/contact-address-title-ico.png"
            />
            <label class="title-label">益狐智造科技（武汉）有限公司</label>
          </div>
          <div class="div-address">
            <p class="p-text">
              电话：{{ phone }}<br />
              邮编：430000<br />
              网站：https://www.foxlean.com<br />
              邮箱：<a :href="emailMailto">{{ email }}</a
              ><br />
              地址：武汉经济技术开发区南太子湖创新谷2期1栋（科大讯飞华中总部）401室
              <br />
            </p>
            <baidu-map
              class="map"
              center="武汉经济技术开发区科大讯飞华中总部"
              :zoom="16"
            >
              <bm-marker
                :position="{ lng: 114.192145, lat: 30.497827 }"
                :dragging="true"
                @click="infoWindowOpen"
                animation="BMAP_ANIMATION_BOUNCE"
              >
                <bm-info-window
                  :show="show"
                  @close="infoWindowClose"
                  @open="infoWindowOpen"
                  >地址：武汉经济技术开发区科大讯飞华中总部</bm-info-window
                >
              </bm-marker>
            </baidu-map>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import constant from "@/assets/constant";
export default {
  name: "ContactAddress",
  data() {
    return {
      show: false,
      phone: constant.phoneNo,
      email: constant.companyMail,
      emailMailto: "mailto:" + constant.companyMail
    };
  },
  methods: {
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    }
  }
};
</script>

<style lang="stylus" scoped>
.title-div {
  position: relative;
  margin-top: 5rem;
  width: 100%;
  height: 2.8rem;

  .title-bg {
    height: 2.8rem;
    width: 400px;
  }

  .title-ico {
    position: absolute;
    height: 1.2rem;
    left: 0.7rem;
    top: 50%;
    transform: translateY(-50%);
  }

  .title-label {
    position: absolute;
    color: #ffffff;
    left: 3.3rem;
    font-size: 1.3rem;
    line-height: 2.8rem;
  }
}

.div-address {
  margin-top: 3rem;
  margin-bottom: 5rem;

  .map {
    width: 100%;
    height: 30rem;
  }
}

.bg-div {
  position: relative;

  .bg-img {
    width: 100%;
  }

  .download {
    position: absolute;
    top: 4rem;
    width: 100%;

    .img-appqr {
      width: 12rem;
      height: 12rem;
      padding-right: 1.25rem;
    }

    .img-weixinqr {
      width: 12rem;
      height: 12rem;
      padding-left: 1.25rem;
    }

    .p-imgappqr {
      width: 12rem;
      height: 1rem;
      color: #ffffff;
      padding-top: 1rem;
      padding-right: 1.25rem;
    }

    .p-imgweixinqr {
      width: 12rem;
      height: 1rem;
      color: #ffffff;
      padding-top: 1rem;
      padding-left: 1.25rem;
    }
  }

  .p-text {
    position: absolute;
    bottom: 1.3rem;
    color: #ffffff;
    font-size: 0.9rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contact/components/ContactAddress.vue